import { useQuery } from '@tanstack/react-query';
import { handleErrorResponse } from '../../utils/handleError';
import { fetchWeeklyHealthFeedback } from '../../apis/survey';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useFetchWeeklySurvey = (patientId: any) => {
  const { data, isError, isLoading, isRefetching, error } = useQuery({
    queryKey: ['health-survey', patientId],
    queryFn: () => fetchWeeklyHealthFeedback(patientId),
    enabled: !!patientId,
  });

  if (isError) {
    handleErrorResponse(error, 'Error Fetching Appointments');
  }

  const weekData = data?.data || [];

  return {
    isLoading,
    isError,
    isRefetching,
    weekData,
  };
};

export default useFetchWeeklySurvey;
